'use strict';

var react = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var isString = require('@userzoomlibraries/toolkit-js-utils/is-string');
var getSafeDocumentBody = require('@userzoomlibraries/toolkit-js-utils/get-safe-document-body');
var getScrollableContainersByElement = require('@userzoomlibraries/toolkit-js-utils/get-scrollable-containers-by-element');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var isString__default = /*#__PURE__*/_interopDefaultCompat(isString);
var getSafeDocumentBody__default = /*#__PURE__*/_interopDefaultCompat(getSafeDocumentBody);
var getScrollableContainersByElement__default = /*#__PURE__*/_interopDefaultCompat(getScrollableContainersByElement);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var useDisableBackgroundScroll = function useDisableBackgroundScroll() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$elementToBlock = _ref.elementToBlock,
      elementToBlock = _ref$elementToBlock === void 0 ? getSafeDocumentBody__default["default"]() : _ref$elementToBlock,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      _ref$recursive = _ref.recursive,
      recursive = _ref$recursive === void 0 ? false : _ref$recursive;

  react.useLayoutEffect(function () {
    var finalElementToBlock = isString__default["default"](elementToBlock) ? document.getElementById(elementToBlock) : elementToBlock;
    var initialOverflow;
    var scrollableContainers;

    if (enabled) {
      if (finalElementToBlock) {
        initialOverflow = finalElementToBlock.style.overflow;
        finalElementToBlock.style.overflow = 'hidden';

        if (recursive) {
          scrollableContainers = getScrollableContainersByElement__default["default"](finalElementToBlock);
          scrollableContainers.forEach(function (eachContainer) {
            // eslint-disable-next-line no-param-reassign
            eachContainer.dataset.initialOverflow = eachContainer.style.overflow; // eslint-disable-next-line no-param-reassign

            eachContainer.style.overflow = 'hidden';
          });
        }
      }
    }

    return function () {
      if (enabled && finalElementToBlock) {
        finalElementToBlock.style.overflow = initialOverflow;

        if (recursive) {
          scrollableContainers.forEach(function (eachContainer) {
            // eslint-disable-next-line no-param-reassign
            eachContainer.style.overflow = eachContainer.dataset.initialOverflow; // eslint-disable-next-line no-param-reassign

            delete eachContainer.dataset.initialOverflow;
          });
        }
      }
    };
  }, [elementToBlock, recursive, enabled]);
};

useDisableBackgroundScroll.HOOK_ID = 'Gearz.ReactHooks.useDisableBackgroundScroll';
useDisableBackgroundScroll.returnType = undefined;
useDisableBackgroundScroll.parameterTypes = {
  parameter: PropTypes__default["default"].shapeWithDescription({
    elementToBlock: PropTypes__default["default"].oneOfTypeWithDescription([PropTypes__default["default"].instanceOf(HTMLElement), PropTypes__default["default"].string], 'Element to block its scroll.'),
    recursive: PropTypes__default["default"].boolWithDescription('Flag to disable all the scrollable parents of the elementToBlock.'),
    enabled: PropTypes__default["default"].boolWithDescription('Flag to activate/deactivate the block.')
  }, 'Settings to disable the background scroll.')
};
useDisableBackgroundScroll.defaultParameters = {
  parameter: {
    elementToBlock: getSafeDocumentBody__default["default"](),
    enabled: true,
    recursive: false
  }
};

module.exports = useDisableBackgroundScroll;
